import { supabase } from '@/integrations/supabase/client';

const BASE = 'https://seniorthrive.com';

function normalizeUrl(pathOrUrl: string) {
  if (!pathOrUrl) return BASE;
  if (pathOrUrl.startsWith('http')) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${BASE}${path}`;
}

export interface CrawlResult {
  total: number;
  processed: number;
  successful: number;
  failed: number;
  results: Array<{
    url: string;
    html?: string;
    error?: string;
    status: number;
    timestamp: string;
  }>;
  summary: {
    totalUrls: number;
    processedUrls: number;
    successfulCrawls: number;
    failedCrawls: number;
    robotsRules: { disallow: string[] };
    crawlTimestamp: string;
  };
}




export const seoFetchService = {
  async fetchHtml(pathOrUrl: string): Promise<{ html: string; url: string }> {
    const url = normalizeUrl(pathOrUrl);
    const { data, error } = await supabase.functions.invoke('seo-fetch', {
      body: { action: 'fetch', url },
    });
    if (error) throw new Error(error.message);
    if (!data?.html) throw new Error('Empty response from seo-fetch');
    return { html: data.html as string, url: (data.url as string) || url };
  },

  async fetchSitemap(): Promise<{ urls: string[]; total: number }> {
    const { data, error } = await supabase.functions.invoke('seo-fetch', {
      body: { action: 'sitemap' },
    });
    if (error) throw new Error(error.message);
    return { 
      urls: (data?.urls as string[]) || [], 
      total: (data?.total as number) || 0 
    };
  },

  async crawlFullSite(maxPages: number = 50): Promise<CrawlResult> {
    const { data, error } = await supabase.functions.invoke('seo-fetch', {
      body: { action: 'crawl', maxPages },
    });
    if (error) throw new Error(error.message);

    const payload: any = data;
    if (payload?.results && Array.isArray(payload.results)) {
      return payload as CrawlResult;
    }
    if (payload?.message) {
      // Background mode: return an empty, typed result so callers can detect and fallback
      return {
        total: typeof payload.maxPages === 'number' ? payload.maxPages : maxPages,
        processed: 0,
        successful: 0,
        failed: 0,
        results: [],
        summary: {
          totalUrls: typeof payload.maxPages === 'number' ? payload.maxPages : maxPages,
          processedUrls: 0,
          successfulCrawls: 0,
          failedCrawls: 0,
          robotsRules: { disallow: [] },
          crawlTimestamp: new Date().toISOString(),
        },
      } as CrawlResult;
    }
    return payload as CrawlResult;
  },
};
